import React, { useState } from "react"
import { Highlight, themes } from "prism-react-renderer"

export const Code = ({ codeString, language }) => {
  const [copied, setCopied] = useState(false)
  const label = language || "code"

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codeString)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1600)
    } catch (e) {
      /* ignore */
    }
  }

  return (
    <Highlight theme={themes.nightOwl} code={codeString} language={label}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <div className="gatsby-highlight" data-language={label}>
          <div className="gatsby-highlight__bar">
            <span>{label}</span>
            <button type="button" onClick={copy} aria-label="Kopiera kod">
              {copied ? "Kopierad" : "Kopiera"}
            </button>
          </div>
          <pre className={className} style={style}>
            {tokens.map((line, i) => (
              <div {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        </div>
      )}
    </Highlight>
  )
}
